import { RouterState } from "react-router";
import { useScroll } from "react-router-scroll";

/**
 * React-router middleware to change whether page scrolls when transitioning between routes.
 * Default settings are totreat navigation to diff query string parameter on same page as a full transition.
 * Usage:  <Router {...renderProps} render={applyRouterMiddleware(scrollOnTransition)} />
 */
export const scrollOnTransition = useScroll((from: RouterState, to: RouterState) => {
  if (!from || !to) {
    return true;
  }

  if (from.location.pathname === to.location.pathname) {
    return false;
  }

  // To disable scrolling on transition, use /core/atoms/Link.tsx:
  // <Link to={route} scrollOnTransition={false} />
  const { scrollOnTransition = true } = (to.location.state || {});
  return scrollOnTransition;
});
